import { cx } from "@emotion/css";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/pl";
import { useState } from "react";
import { BlockedActions } from "src/components/Course/lessons/Lesson/LessonComponents/Actions/BlockedActions";
import { InProgressActions } from "src/components/Course/lessons/Lesson/LessonComponents/Actions/InProgressActions";
import { WaitingActions } from "src/components/Course/lessons/Lesson/LessonComponents/Actions/WaitingActions";
import { BlockedDetails } from "src/components/Course/lessons/Lesson/LessonComponents/Details/BlockedDetails";
import InProgressDetails from "src/components/Course/lessons/Lesson/LessonComponents/Details/InProgressDetails";
import { WaitingDetails } from "src/components/Course/lessons/Lesson/LessonComponents/Details/WaitingDetails";
import { LessonNote } from "src/components/Course/lessons/Lesson/LessonNote";

import DefaultScoreView from "./DefaultScoreView";

dayjs.locale(import.meta.env.LANG);

export default function LessonView({ row, className, lesson, folders = [] }) {
	const [isNoteOpen, setIsNoteOpen] = useState(!!lesson.userNote);
	const toggleNote = () => setIsNoteOpen(!isNoteOpen);

	if (row.lessonStatus === "blocked") {
		return (
			<DefaultScoreView
				className={cx("disabled-lesson", className)}
				row={row}
				Details={<BlockedDetails className="mr-32" lesson={lesson} />}
				Actions={<BlockedActions lesson={lesson} />}
			/>
		);
	}

	if (row.lessonStatus === "waiting") {
		return (
			<DefaultScoreView
				className={className}
				row={row}
				Details={<WaitingDetails className="mr-32" lesson={lesson} />}
				Actions={<WaitingActions lesson={lesson} toggleNote={toggleNote} />}
			>
				{isNoteOpen && (
					<LessonNote
						lesson={lesson}
						closeNotes={() => setIsNoteOpen(false)}
						folders={folders}
					/>
				)}
			</DefaultScoreView>
		);
	}

	return (
		<DefaultScoreView
			className={className}
			row={row}
			Details={<InProgressDetails className="mr-32" lesson={lesson} />}
			Actions={<InProgressActions lesson={lesson} toggleNote={toggleNote} />}
		>
			{isNoteOpen && (
				<LessonNote
					lesson={lesson}
					closeNotes={() => setIsNoteOpen(false)}
					folders={folders}
				/>
			)}
		</DefaultScoreView>
	);
}
